import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface WhatsNewData {
  version: string;
  features: string[];
}

@Component({
  selector: 'app-whats-new-modal',
  templateUrl: './whats-new-modal.component.html',
  styleUrls: ['./whats-new-modal.component.scss']
})
export class WhatsNewModalComponent {
  constructor(
    public dialogRef: MatDialogRef<WhatsNewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WhatsNewData
  ) {}

  close(): void { this.dialogRef.close(); }
}
